export default __webpack_public_path__ + "static/media/sep2023-5.f256f6af.jpg";